// extracted by mini-css-extract-plugin
module.exports = {"root":"BackImages_root__2D6PY","title":"BackImages_title__22pq-","images":"BackImages_images__uj4zB"};